import React from 'react';
import { GridFilterCellProps } from '@progress/kendo-react-grid';
import { DatePicker } from '@progress/kendo-react-dateinputs';

const DateFilter: React.FC<GridFilterCellProps> = (props) => {
  const handleChange = (e: any) => {
    props.onChange({
      value: e.value,
      operator: 'eq',
      syntheticEvent: e.syntheticEvent
    });
  };

  return (
    <div className="k-filtercell">
      <DatePicker
        format={"dd/MM/yyyy"}
        value={props.value ? new Date(props.value) : null}
        onChange={handleChange}
        placeholder='day/month/year'
      />
    </div>
  );
};

export default DateFilter;
